import { Data_getInstance15v98og7gesym as Data_getInstance } from './adapter/GrantSlackAccessMutation_ResponseAdapter.mjs';
import { getBooleanHashCode1bbj3u6b3v0a7 as getBooleanHashCode } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import {
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { obj2vqjd1bjrpmyg as obj } from '../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/Adapters.mjs';
import { Companion_getInstance1m1mmkl5t8eg3 as Companion_getInstance } from './type/Mutation.mjs';
import { Builder320ghmibyd2no as Builder } from '../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/CompiledGraphQL.mjs';
import { GrantSlackAccessMutationSelections_getInstancezhlvzz33un89 as GrantSlackAccessMutationSelections_getInstance } from './selections/GrantSlackAccessMutationSelections.mjs';
import { GrantSlackAccessMutation_VariablesAdapter_instance70s4jr9spry0 as GrantSlackAccessMutation_VariablesAdapter_instance } from './adapter/GrantSlackAccessMutation_VariablesAdapter.mjs';
import { Mutationkenyz0l5btz as Mutation } from '../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/Mutation.mjs';
import { ApolloAdaptableWith1g871415y7ifs as ApolloAdaptableWith } from '../../../../../../apollo-kotlin-apollo-annotations/com/apollographql/apollo/annotations/ApolloAdaptableWith.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var DataClass;
function Data() {
  if (DataClass === VOID) {
    class $ {
      constructor(grantSlackAccess) {
        this.a6g_1 = grantSlackAccess;
      }
      toString() {
        return 'Data(grantSlackAccess=' + this.a6g_1 + ')';
      }
      hashCode() {
        return this.a6g_1 == null ? 0 : getBooleanHashCode(this.a6g_1);
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof Data()))
          return false;
        if (!(this.a6g_1 == other.a6g_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'Data', VOID, VOID, VOID, VOID, VOID, {1: Data_getInstance});
    DataClass = $;
  }
  return DataClass;
}
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      constructor() {
        Companion_instance = this;
        this.b6g_1 = obj(Data_getInstance());
        this.c6g_1 = (new (Builder())('data', Companion_getInstance().w6d_1)).s43(GrantSlackAccessMutationSelections_getInstance().f6g_1).i37();
        this.d6g_1 = 'e874514c291f1d673c3b491e79bafcaaf1514da74fdcb9851c57b44e01a26f89';
        this.e6g_1 = 'grantSlackAccess';
      }
      z6d() {
        return 'mutation grantSlackAccess($input: GrantSlackAccessInput!) { grantSlackAccess(input: $input) }';
      }
    }
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance_0() {
  if (Companion_instance === VOID)
    new (Companion())();
  return Companion_instance;
}
var GrantSlackAccessMutationClass;
function GrantSlackAccessMutation() {
  if (GrantSlackAccessMutationClass === VOID) {
    class $ {
      constructor(input) {
        Companion_getInstance_0();
        this.g6g_1 = input;
      }
      b6e() {
        return 'e874514c291f1d673c3b491e79bafcaaf1514da74fdcb9851c57b44e01a26f89';
      }
      operationId() {
        return this.b6e();
      }
      l47() {
        return Companion_getInstance_0().z6d();
      }
      c6e() {
        return 'grantSlackAccess';
      }
      operationName() {
        return this.c6e();
      }
      p46(writer, customScalarAdapters, withDefaultValues) {
        GrantSlackAccessMutation_VariablesAdapter_instance.h6g(writer, this, customScalarAdapters, withDefaultValues);
      }
      o46() {
        return Companion_getInstance_0().b6g_1;
      }
      toString() {
        return 'GrantSlackAccessMutation(input=' + this.g6g_1.toString() + ')';
      }
      hashCode() {
        return this.g6g_1.hashCode();
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof GrantSlackAccessMutation()))
          return false;
        if (!this.g6g_1.equals(other.g6g_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'GrantSlackAccessMutation', VOID, VOID, [Mutation()]);
    GrantSlackAccessMutationClass = $;
  }
  return GrantSlackAccessMutationClass;
}
//region block: exports
export {
  Data as Data1rorqhenzwzbc,
  GrantSlackAccessMutation as GrantSlackAccessMutationfs5xfcp7iisz,
};
//endregion

//# sourceMappingURL=GrantSlackAccessMutation.mjs.map
